import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { Button, Form, Input } from 'antd';
import { EyeInvisibleOutlined, EyeTwoTone } from '@ant-design/icons';
import { updatePasswordPINAction } from '../../store/login/actions';
import {
  getCustomerCode,
  getLoginStatus,
  getPhoneNumber,
  getToken,
} from '../../store/login/selectors';
import {useTranslation} from "react-i18next";

const UpdateProfile = () => {
  const dispatch = useDispatch();
  const [form] = Form.useForm();
  const token = useSelector(getToken);
  const [errorPassword, setErrorPassword] = useState('');
  const [errorConfirmationPassword, setErrorConfirmationPassword] =
    useState('');
  const [errorFullName, setErrorFullName] = useState('');
  const navigate = useNavigate();
  const phoneNumber = useSelector(getPhoneNumber);
  const customerCode = useSelector(getCustomerCode);
  const loginStatus = useSelector(getLoginStatus);
  const {t} = useTranslation();
  useEffect(() => {
    if ((!phoneNumber && !customerCode) || loginStatus) {
      navigate('/');
    }
  }, [phoneNumber, loginStatus, customerCode]);

  const validateForm = () => {
    const { fullName, password, password_confirmation } = form.getFieldsValue();
    let isValid = true;
    setErrorFullName('');
    setErrorPassword('');
    setErrorConfirmationPassword('');

    if (!fullName || !fullName.length) {
      setErrorFullName('global_full_name');
      isValid = false;
    } else if (fullName.slice(0, 1) === ' ' || fullName.slice(-1) === ' ') {
      setErrorFullName(
        'validation_spaces_full_name',
      );
      isValid = false;
    }

    if (!password || !password.length) {
      setErrorPassword('validation_required_password');
      isValid = false;
    } else if (password.slice(0, 1) === ' ' || password.slice(-1) === ' ') {
      setErrorPassword(
        'validation_spaces_password',
      );
      isValid = false;
    } else if (password.length < 6 || password.length > 20) {
      setErrorPassword('validation_range_length_password');
      isValid = false;
    }

    if (!password_confirmation || !password_confirmation.length) {
      setErrorConfirmationPassword('validation_required_password');
      isValid = false;
    } else if (password && password !== password_confirmation) {
      setErrorConfirmationPassword('validation_re_enter_password');
      isValid = false;
    }

    return isValid;
  };

  const handleSubmit = () => {
    if (validateForm()) {
      const { fullName, password } = form.getFieldsValue();
      dispatch(
        updatePasswordPINAction({
          phone: phoneNumber,
          user_name: fullName,
          pin: password,
          verified_token: token,
        }),
      );
    }
  };

  return (
    <>
      <Form
        layout="vertical"
        className="w-100"
        onValuesChange={() => validateForm()}
        form={form}
      >
        <Form.Item>
          <div className="page-title mb-3 header-title">{t('section_title_create_new_profile')}</div>
        </Form.Item>
        <Form.Item label={t('global_phone')}>
          <Input disabled value={phoneNumber} />
        </Form.Item>
        <Form.Item label={t('global_full_name')} help={t(errorFullName)} name="fullName">
          <Input maxLength={45} placeholder={t('placeholder_first_last_name')} />
        </Form.Item>
        <Form.Item label={t('input_label_new_password')} help={t(errorPassword)} name="password">
          <Input.Password
            placeholder={t('placeholder_password')}
            iconRender={(visible) =>
              visible ? <EyeTwoTone /> : <EyeInvisibleOutlined />
            }
          />
        </Form.Item>
        <Form.Item
          label={t('input_label_re_enter_new_password')}
          help={t(errorConfirmationPassword)}
          name="password_confirmation"
        >
          <Input.Password
            placeholder={t('placeholder_re_enter_password')}
            iconRender={(visible) =>
              visible ? <EyeTwoTone /> : <EyeInvisibleOutlined />
            }
          />
        </Form.Item>
        <Form.Item>
          <Button type='primary' htmlType='submit' onClick={handleSubmit}>
            {t('button_complete')}
          </Button>
        </Form.Item>
      </Form>
    </>
  );
};

export default UpdateProfile;
